/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class RadiansPlugin extends FunctionPlugin {
    radians(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('RADIANS'), (arg) => arg * (Math.PI / 180));
    }
}
RadiansPlugin.implementedFunctions = {
    'RADIANS': {
        method: 'radians',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER }
        ],
    },
};
